export const NAV_BAR_OPEN = 'NAV_BAR_OPEN'
export const NAV_BAR_CLOSE = 'NAV_BAR_CLOSE'
export const PATIENT_FOLDER_CLOSE = 'PATIENT_FOLDER_CLOSE'

export function navBarOpen () {
  return {
    type: NAV_BAR_OPEN
  }
}

export function navBarClose () {
  return {
    type: NAV_BAR_CLOSE
  }
}

export function patientFolderClose () {
  return {
    type: PATIENT_FOLDER_CLOSE
  }
}
